import { render, staticRenderFns } from "./HaabSetup.vue?vue&type=template&id=cd570348&scoped=true"
import script from "./HaabSetup.vue?vue&type=script&lang=js"
export * from "./HaabSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd570348",
  null
  
)

export default component.exports